import { Injectable } from '@angular/core';
import { FormActionHandlerService } from './base.service';
import { FormActionService } from '../action.service';
import { FormStatusService } from '../status.service';
import { FormShareService } from '../share.service';
import { SwalService } from '../../../fastlane-common/services/swal.service';
import { NavService } from '../../../fastlane-common/services/nav.service';
import { FormDataService } from '../data.service';
import { UserContextService } from '../../../user/services/user-context.service';
import { FormEmailService } from '../email.service';
import { UnlockFormActionHandlerService } from './unlock.service';

@Injectable()
export class NoSignFormActionHandlerService extends FormActionHandlerService {
  constructor(
    private dataService: FormDataService,
    private emailService: FormEmailService,
    private navService: NavService,
    private shareService: FormShareService,
    private statusService: FormStatusService,
    private unlockService: UnlockFormActionHandlerService,
    private swal: SwalService,
    private userContext: UserContextService
  ) {
    super();
  }

  /**
   * A handler associated with a user refusing to sign a form
   * (Generally, only business signatories should be able to see this function.)
   *
   * @memberof NoSignFormActionHandlerService
   */
  exec(): Promise<any> {
    const that = this;
    return new Promise((resolve, reject) => {
      // Change form status to pending
      that.statusService.changeStatus('Pending');
      that.dataService.saveForm().subscribe(
        successfulSave => {
          if (that.userContext.isUserGuest()) {
            // Send email saying the project stakeholders can discuss between themselves why the signee refused to sign
            that.swal.load('Emailing non-signatories to take action...');
            that.emailService
              .sendBusinessSignatoryRefusedToSignEmail()
              .subscribe(
                successfulEmail => {
                  // Disable the temporary link assigned to this guest account
                  // ? todo: implement this functionality -- it should be brand new
                  that.swal
                    .success({
                      title: 'Email sent!',
                      text:
                        'Non-signatories have been notified to take action on this form.'
                    })
                    .then(resolve)
                    .catch(resolve);
                },
                error => {
                  that.swal
                    .error({
                      title: 'Email Failed!',
                      text:
                        'Failed to notify Non-signatories to take action on this form.'
                    })
                    .then(reject)
                    .catch(reject);
                }
              );
          } else {
            // Who will correct the form? -- user answers based on swal question
            that.swal
              .yesOrNo({
                title: 'Would you like to correct this form?',
                text:
                  'Otherwise, non-signatories will be notified to make a correction to this form.'
              })
              .then(() => {
                // ? Potentially scroll to top -- not sure how Kate/Cedeste want this interaction yet
                // Nothing really happens here (for now)
                that.unlockService
                  .exec()
                  .then(resolve)
                  .catch(reject);
              })
              .catch(() => {
                that.swal.load('Emailing non-signatories to take action...');
                that.emailService
                  .sendBusinessSignatoryRefusedToSignEmail()
                  .subscribe(
                    successfulEmail => {
                      that.swal
                        .success({
                          title: 'Email sent!',
                          text:
                            'Non-signatories have been notified to take action on this form.'
                        })
                        .then(resolve)
                        .catch(resolve);
                    },
                    error => reject('Failed to email non-signatories.')
                  );
              });
          }
        },
        error => {
          if (error === 409) {
            reject(error);
          } else {
            reject('Failed to update the status of this form.');
          }
        }
      );
    });
  }
}
